import React, { useContext } from "react";
import { AppContext } from "../Index";
import FamilySubGroup from "./FamilySubGroup";

const FamilyGroup = ({ familyGroup }) => {
  const { selectedFamilyGroup, setSelectedFamilyGroup } =
    useContext(AppContext);

  return (
    <div className="accordion-item" key={familyGroup.itemCode}>
      <h2 className="accordion-header" id="headingOne">
        <button
          className={`accordion-button ${selectedFamilyGroup === familyGroup.itemCode ? "" : "collapsed"
            }`}
          type="button"
          data-bs-toggle="collapse"
          // data-bs-target={`#${familyGroup.itemCode}`}
          aria-expanded="true"
          aria-controls={`${familyGroup.itemCode}`}
          onClick={(ev) => {
            setSelectedFamilyGroup(
              selectedFamilyGroup === familyGroup.itemCode
                ? null
                : familyGroup.itemCode,
            );
          }}
        >
          {familyGroup.name}
        </button>
      </h2>
      <div
        id={`${familyGroup.itemCode}`}
        className={`accordion-collapse collapse ${selectedFamilyGroup === familyGroup.itemCode ? "show" : ""
          }`}
        aria-labelledby="headingOne"
        data-bs-parent={`${familyGroup.itemCode}`}
      >
        <div className="accordion-body">
          {familyGroup.familyGroup.map((fg) => {
            // return fg?.menuItem?.map((mi) => (
            //   <FoodItem menuItem={mi} key={mi.itemCode} />
            // ));
            return <FamilySubGroup familyGroup={fg} key={fg.itemCode} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default FamilyGroup;
